
import * as handlebars_family from "../handlebars_family.ts";

const TPL = handlebars_family.addTemplate("calendar/searchresult",{"1":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <flexrow data-fw-onclick=\"evtclick|"
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"metaId") : depth0), depth0))
    + "\"><icon style=\"margin:12px;color:"
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"color") : depth0), depth0))
    + "\">"
    + container.escapeExpression((lookupProperty(helpers,"iconlib")||(depth0 && lookupProperty(depth0,"iconlib"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"calendar.ic_calendar_sidebar",{"name":"iconlib","hash":{},"data":data,"loc":{"start":{"line":1,"column":105},"end":{"line":1,"column":147}}}))
    + "</icon><flexcol><line>"
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"text") : depth0), depth0))
    + "</line><line class=\"sub4\">"
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"i18ndateformat") : depth0), depth0))
    + "</line></flexcol></flexrow> ";
},"3":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <flexrow><icon style=\"margin:12px;color:"
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"color") : depth0), depth0))
    + "\">"
    + container.escapeExpression((lookupProperty(helpers,"iconlib")||(depth0 && lookupProperty(depth0,"iconlib"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"ic_search_off",{"name":"iconlib","hash":{},"data":data,"loc":{"start":{"line":1,"column":315},"end":{"line":1,"column":342}}}))
    + "</icon><line>"
    + container.escapeExpression(lookupProperty(helpers,"i18n").call(depth0 != null ? depth0 : (container.nullContext || {}),"eventCalendarNav.noresult",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":1,"column":355},"end":{"line":1,"column":391}}}))
    + "</line></flexrow> ";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),depth0,{"name":"each","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(3, data, 0),"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":1,"column":418}}})) != null ? stack1 : "");
},"useData":true});
export default TPL;